<template>
  <div>
    <PayPop
      v-if="show"
      :ext="ext"
      :gid="gid"
      :sid="sid"
      :money="money"
      @close="show = false"
      @pay-success="success"
    />
    <div v-if="paySuccess" class="cp-pay-success-pop">
      <p>支付成功</p>
    </div>
  </div>
</template>

<script>
import PayPop from './index'
export default {
  components: {
    PayPop
  },
  data() {
    return {
      ext: '',
      gid: 0,
      sid: 0,
      money: 0,
      show: false,
      paySuccess: false
    }
  },
  watch: {
    show(val) {
      this.$emit('toggle', val)
    }
  },
  mounted() {
    this.onMessage()
  },
  methods: {
    success() {
      this.paySuccess = true
      setTimeout(() => {
        this.show = false
        this.paySuccess = false
      }, 2000)
    },
    onMessage() {
      window.addEventListener('message', (event) => {
        const data =
          typeof event.data === 'object' ? event.data : JSON.parse(event.data)
        const { ext = '', gid, money, sid, type } = data
        if (type !== 'recharge') return
        this.ext = typeof ext === 'object' ? JSON.parse(ext) : ext
        this.gid = +gid
        this.sid = +sid
        this.money = +money
        const succfn = () => {
          this.show = true
        }
        this.$util.realNameAuth('pay', 'default', succfn)
      })
    }
  }
}
</script>

<style lang="scss">
.cp-pay-success-pop {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 150px;
  font-size: 16px;
  color: #ffffff;
  background: #508aff;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  z-index: 999;
  p {
    padding: 18px 0;
    text-align: center;
    &:before {
      display: block;
      content: '';
      width: 18px;
      height: 18px;
      margin: 0 auto 8px;
      background: url(~assets/img/commen/ok-ico2.png);
    }
  }
}
</style>
